import { Controller } from "@hotwired/stimulus"
import Select2 from 'select2'
import 'jquery-validation'
import 'select2/dist/css/select2.css'

window.select2 = Select2()

export default class extends Controller {
  static targets = ['studentsInput', 'classroomsInput', 'addBtnStudents', 'addBtnClassrooms']

  connect() {
    $('.js-select2-multiple').select2();
  }

  showStudentsInput() {
    if (this.hasStudentsInputTarget) {
      this.#removeValidationError(this.studentsInputTarget)
      this.#showInput(this.studentsInputTarget)
    }
  }

  showClassroomsInput() {
    if (this.hasClassroomsInputTarget) {
      this.#removeValidationError(this.classroomsInputTarget)
      this.#showInput(this.classroomsInputTarget)
    }
  }

  #removeValidationError(target) {
    let errorElement = target.parentElement.querySelector("div.error")

    if (errorElement) {
      errorElement.remove()
    }
  }

  #showInput(target) {
    this.addBtnStudentsTarget.classList.add("hidden")
    this.addBtnClassroomsTarget.classList.add("hidden")

    this.addBtnStudentsTarget.nextElementSibling.classList.remove("mb-32px")
    this.addBtnClassroomsTarget.nextElementSibling.classList.remove("mb-32px")
    target.classList.remove("hidden")
    target.required = true
    target.querySelector(".select2-selection--multiple").click()
  }

}
